import { FilterTypes, FormInputCell } from "@repo/design-system/components/grids";
import { FilterMatchMode } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

// Build initial filters
export const buildInitialFilters = (columns) => {
    const filters = {};

    columns.forEach(col => {
        if (!col?.config?.filter || !col.field) return;

        filters[col.field] = {
            value: null,
            matchMode: FilterMatchMode.CONTAINS
        };
    });

    return filters;
};

// Render column filter
export const renderColumnFilter = (col) => {
    if (!col?.config?.filter) return null;

    const type = col?.config?.filter?.type || "text";

    switch (type) {
        case FilterTypes.DROPDOWN:
            return (options) => (
                <Dropdown
                    value={options.value}
                    options={col?.config?.filter?.options}
                    onChange={(e) =>
                        options.filterApplyCallback(e.value)
                    }
                    placeholder="Select"
                    className="p-column-filter"
                />
            );

        case FilterTypes.DATE:
            const { dateFormat } = col?.config || {};
            return (options) => (
                <Calendar
                    value={options.value}
                    onChange={(e) =>
                        options.filterApplyCallback(e.value)
                    }
                    dateFormat="dd/mm/yy"
                    placeholder="Select date"
                    className="p-column-filter"
                />
            );

        default:
            return (options) => (
                <FormInputCell id="search" name="search" cssClass=""
                    value={options.value || ""} onBlur={() => ""}
                    onChange={(dataField, value) => options.filterApplyCallback(value)}
                    placeholder={`Search ${col.header}`}
                />
            );
    }
};
